import React from 'react'
import { Icon } from '../Icon'

export default function CloudIcon() {
  return <Icon icon="cloud" />
}
